import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import { TableOfContents } from './TableOfContents';

const drawerWidth = 275;

// REF: https://mui.com/components/drawers/#clipped-under-the-app-bar
export function LeftDrawer(props: any) {
  const drawer = (
    <Box sx={{ overflow: 'auto' }}>
        <TableOfContents></TableOfContents>
    </Box>
  );

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { mx: 0, width: drawerWidth, boxSizing: 'border-box' },
      }}
      anchor="left"
    >
      <Toolbar />
        {drawer}
    </Drawer>
  )
}
